module.exports = __webpack_public_path__ + "static/img/person_schommer.374aeb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bln-assets/person_schommer.jpg
// module id = ZaXU
// module chunks = 1